<script>
import { mapMutations, mapActions, mapGetters } from 'vuex';
import request from '@/services/request';

import ModalFormComponent from '@/components/partner/ModalFormAdvancesComponent.vue';
import ModalTableComponentPays from '@/components/pays/ModalTableComponent.vue';
import ModalPayCheckbookFastComponent from '@/components/pays/ModalPayCheckbookFastComponent.vue';
import ModalPayGroupCheckbookFastComponent from '@/components/pays/ModalPayGroupCheckbookFastComponent.vue';
import ModalDownloadFileComponent from '@/components/partner/ModalDownloadFileComponent.vue';
import Catalogue from '@/services/catalogue';

import Pagination from 'vue-pagination-2';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
	name: "partner-table",
	components: {
		ModalFormComponent,
		ModalTableComponentPays,
		ModalPayCheckbookFastComponent,
		ModalPayGroupCheckbookFastComponent,
		ModalDownloadFileComponent,
		Pagination,
		DatePicker,
	},
	data() {
		return {
			Arrauthorized: [],
			sendGroup: false,
			loadAll: false,
			advances: [],
			advances_p: [],
			advances_s: [],
			checks: [],
			checks_p: [],
			checks_s: [],
			name: '',
			editAdvance: true,
			trigger:true,
			init:false,
			search: {
				date: '',
				company_id: '',
				user_id : '',
				share:1,
				authorized:1
			},
			order:{
				id:-1,
				name:-1,
				amount:-1,
				paid:-1,
				date:0,
				approved:-1,
			},
			view: 1,
			page: 1,
			per_page: 10,
			send: false,
			catalogue: new Catalogue(),
			load: false,
			isExpanded: []
		}
	},
	async mounted() {
		this.loadAll = true;

		this.list();
		if(this.authUser.organization_charts_id == 10 || this.authUser.organization_charts_id == 15){ 
            this.catalogue.get_companies_users(this.authUser.id);
        }else{
            this.catalogue.get_companies_buildings();
        }

		this.catalogue.get_users_profile(8);
		this.setHeaderTitle('Adelantos');
		this.loadAll = false;
	},
	created() {
		Event.$on("event-load-advances", () => {
			this.list();
		});
	},
	methods: {
		approve(advance) {
		// approve(bill, edit = false) {


			let tit = 'Aprobar Adelanto';
			let txt = 'Seguro que quiere aprobar el adelanto de dividendos';

			this.$swal({
				title: tit,
				text: txt,
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Ok',
				cancelButtonText: 'Cancelar'
			}).then(async (result) => {
				if (result.isConfirmed) {
					let _endpoint = '/partners/advance_approve';
					let form = {
						id: advance.id
					};
					try {
						let response = await request.post(_endpoint, form).then(function (response) { return response; });
						this.successNotification(response.data.message);
						Event.$emit('event-load-advances');
					} catch (error) {
						this.errors = await this.errorNotification(error)
					}
				}
			});

		},
		async newAdvance(account = {}, edit = true) {
			this.editAdvance = edit;
			Event.$emit('event-show-addAdvance', account, edit);
		},
		paymentConditions() {
			return (this.search.authorized==1 && this.advances_s && this.advances_s.length > 0) ||
				(this.search.company_id != '' &&
				(
					this.search.date == '' ||
					this.search.date[0]==null
				) &&
				this.search.user_id == '' &&
				this.search.type_payment_id == '' &&
				(this.checks_s && this.checks_s.length > 0 && this.search.paid==0))
		},
		paymentConditionsCheck() {
			return this.search.company_id != '' &&
				this.search.type_payment_id == 6 &&
				this.search.user_id == '' &&
				(
					this.search.date == '' ||
					this.search.date[0] == null
				) &&
				(this.checks_s && this.checks_s.length > 0 && this.search.paid==0)
		},
		async formDataPayFast(check) {
			let company_id = check.advance.company_id;
			await this.catalogue.getBankAccountCompany(company_id);
			let bancks = this.catalogue.bank_account_company;
			let banco = [];
			bancks.forEach(function (bank) {
				let name = '';
				if (bank.bank) {
					name += bank.bank.name + ' - ';
				}
				name += bank.number;
				banco['_' + bank.id] = name;
			});

			if (bancks.length == 0) {
				this.$swal({
					title: "No se cuenta con cuenta",
					text: "No se puede pagar es requerida una cuenta",
					icon: "info"
				});
			}

			if (bancks.length > 1) {
				const { value: bank_id } = await this.$swal({
					title: "Cuenta de banco",
					html: '<div class="col-12"><input type="date" id="input_date_12" class="form-control"></div>',
					input: "select",
					inputOptions: banco,
					inputPlaceholder: "Seleccione una cuenta de banco",
					showCancelButton: true,
					inputValidator: (value) => {
						return new Promise((resolve) => {
							let date = document.getElementById('input_date_12').value;
							if (value !== "" && date !== "") {
								resolve();
							} else {
								if (value == "") {
									resolve("Es requerida la cuenta de banco");
								} else {
									resolve("Es requerida la fecha");
								}
							}
						});
					}
				});

				if (bank_id) {
					this.$modal.show('LoadPay');
					this.sendGroup = true;
					let form = {
						check_id: check.id,
						bank_id: bank_id.substring(1),
						date: document.getElementById('input_date_12').value,
					};
					let _endpoint = '/partners/pay_advance';
					try {
						let { data } = await request.post(_endpoint, form)
						if (data) {
							this.successNotification(data.message);
							this.list();
							Event.$emit('event-load-advances');
							this.sendGroup = false;

						}
					} catch (error) {
						this.errors = {};
						if (error.response) {
							this.errors = await this.errorNotification(error);
							this.sendGroup = false;
						}
					}
					this.$modal.hide('LoadPay');
				}
			} else {
				this.$swal({
					title: 'Pago rápido',
					html: 'Se aprobará el pago rápido<br><br><input type="date" id="input_date_2" class="form-control">',
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Pagar',
					cancelButtonText: 'Cancelar'
				}).then(async (result) => {
					if (result.isConfirmed) {
						this.$modal.show('LoadPay');
						this.sendGroup = true;
						let form = {
							check_id: check.id,
							bank_id: bancks[0].id,
							date: document.getElementById('input_date_2').value,
						};
						let _endpoint = '/partners/pay_advance';
						try {
							let { data } = await request.postMedia(_endpoint, form)
							if (data) {
								this.successNotification(data.message);
								this.list();
								Event.$emit('event-load-advances');
								this.sendGroup = false;
							}
						} catch (error) {
							this.errors = {};
							if (error.response) {
								this.errors = await this.errorNotification(error);
								this.sendGroup = false;

							}
						}
						this.$modal.hide('LoadPay');
					}
				});
			}

		},
		async formDataPaysFastCheckbook(check) {
			Event.$emit('event-show-addPayCheckbookFast', check);
		},
		formListPays(check) {
			Event.$emit('event-show-listPays', check);
		},
		async formDataApproveGroup() {
			let Arrauthorized = this.Arrauthorized;
			this.sendGroup = true;
			let form = {
				advances_id: Arrauthorized,
				description: 'Adelantos Aprobados'
			};
			let _endpoint = '/advances_group';
			try {
				let { data } = await request.postMedia(_endpoint, form)
				if (data) {
					this.successNotification(data.message);
					this.list();
					Event.$emit('event-load-advances');
					this.sendGroup = false;
				}
			} catch (error) {
				this.errors = {};
				if (error.response) {
					this.errors = await this.errorNotification(error);
					this.sendGroup = false;
				}
			}
		},
		async formDataPaysFastGroup() {
			let company_id = this.search.company_id;
			let Arrauthorized = this.Arrauthorized;
			await this.catalogue.getBankAccountCompany(company_id);
			let bancks = this.catalogue.bank_account_company;
			let banco = [];
			bancks.forEach(function (bank) {
				let name = '';
				if (bank.bank) {
					name += bank.bank.name + ' - ';
				}
				name += bank.number;
				banco['_' + bank.id] = name;
			});

			if (bancks.length == 0) {
				this.$swal({
					title: "No se cuenta con cuenta",
					text: "No se puede pagar es requerida una cuenta",
					icon: "info"
				});
			}

			if (bancks.length > 1) {
				const { value: bank_id } = await this.$swal({
					title: "Cuenta de banco",
					html: '<div class="col-12"><input type="date" id="input_date_12" class="form-control"></div>',
					input: "select",
					inputOptions: banco,
					inputPlaceholder: "Seleccione una cuenta de banco",
					showCancelButton: true,
					inputValidator: (value) => {
						return new Promise((resolve) => {
							let date = document.getElementById('input_date_12').value;
							if (value !== "" && date !== "") {
								resolve();
							} else {
								if (value == "") {
									resolve("Es requerida la cuenta de banco");
								} else {
									resolve("Es requerida la fecha");
								}
							}
						});
					}
				});

				if (bank_id) {
					this.$modal.show('LoadPay');
					this.sendGroup = true;
					let form = {
						checks_id: Arrauthorized,
						bank_id: bank_id.substring(1),
						date: document.getElementById('input_date_12').value,
						description: 'Pago aprobado'
					};
					let _endpoint = '/pays_group';
					try {
						let { data } = await request.postMedia(_endpoint, form)
						if (data) {
							this.successNotification(data.message);
							this.list();
							Event.$emit('event-load-advances');
							this.sendGroup = false;

						}
					} catch (error) {
						this.errors = {};
						if (error.response) {
							this.errors = await this.errorNotification(error);
							this.sendGroup = false;
						}
					}
					this.$modal.hide('LoadPay');
				}
			} else {

				this.$swal({
					title: 'Pago rápido',
					text: 'Se aprobara el pago rápido',
					html: '<input type="date" id="input_date_2" class="form-control">',
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Pagar',
					cancelButtonText: 'Cancelar'
				}).then(async (result) => {
					if (result.isConfirmed) {
						this.$modal.show('LoadPay');
						this.sendGroup = true;
						let form = {
							checks_id: Arrauthorized,
							bank_id: bancks[0].id,
							date: document.getElementById('input_date_2').value,
							description: 'Pago aprobado'
						};
						let _endpoint = '/pays_group';
						try {
							let { data } = await request.postMedia(_endpoint, form)
							if (data) {
								this.successNotification(data.message);
								Event.$emit('event-load-advances');
								this.sendGroup = false;
							}
						} catch (error) {
							this.errors = {};
							if (error.response) {
								this.errors = await this.errorNotification(error);
								this.sendGroup = false;

							}
						}
						this.$modal.hide('LoadPay');
					}
				});
			}
		},
		formDataPaysFastGroupCheck() {
			Event.$emit('event-show-showPayGroupCheckbookFast', this.search, this.checks_s);
		},
		exportData() {
			// Event.$emit('event-show-downloadFile');
			let filter = this.search;
			filter.type = 'advance';
			filter.user_logged = this.authUser.id;

			let data = new URLSearchParams(filter).toString();

            let _url = this.globalUrlFiles + '/partners/advances/export?'+data;            
			window.open(_url, '_blank');
		},
		downloadPDF(id) {
			let filter = this.globalUrlFiles + '/partners/advances/'+id+'/pdf';
			window.open(filter, '_blank');
		},
		deleted: function (obj) {
			if(this.search.authorized==1){
				let tit = 'Eliminar Adelanto';
				let txt = 'Seguro que quiere eliminar el adelanto de dividendos';

				this.$swal({
					title: tit,
					text: txt,
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Ok',
					cancelButtonText: 'Cancelar'
				}).then((result) => {
					if (result.isConfirmed) {
						this.callDeleted(obj.id);
					}
				});
			}else{
				let tit = 'Eliminar aprobación';
				let txt = 'Seguro que quiere eliminar las aprobaciones del adelanto '+obj.advance.description;

				this.$swal({
					title: tit,
					text: txt,
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Ok',
					cancelButtonText: 'Cancelar'
				}).then((result) => {
					if (result.isConfirmed) {
						this.callDeleted(obj.id);
					}
				});
			}
		},
		async callDeleted(id) {
			if(this.search.authorized==1){
				let _endpoint = 'advances/' + id;
				try {
					let response = await request.destroy(_endpoint).then(function (response) { return response; });
					Event.$emit('event-load-advances');
					this.successNotification(response.data.message);
				} catch (error) {
					this.errors = await this.errorNotification(error)
				}
			}else{
				let _endpoint = '/checks/' + id;
				try {
					let response = await request.destroy(_endpoint).then(function (response) { return response; });
					Event.$emit('event-loads-advances');
					this.successNotification(response.data.message);
				} catch (error) {
					this.errors = await this.errorNotification(error)
				}
			}
		},
		sumdata() {
			let sum = 0;
			let sum1 = 0;
			let sum2 = 0;
			let sum3 = 0;

			if (this.advances_s.length>0) {
				this.advances_s.forEach(function (advance) {
					if (advance.amount) {
						sum += parseFloat(advance.amount);
					}
				});
				return sum;
			}
			if (this.checks_s.length>0) {
				this.checks_s.forEach(function (buy) {
					if (buy.amount) {
						sum1 += parseFloat(buy.amount);
					}
					if (buy.credit) {
						sum1 += parseFloat(buy.credit);
					}
					sum2 += parseFloat(buy.amount_payable);
					sum3 += parseFloat(buy.sum_pays);

				});
				return [sum1, sum2, sum3];
			}
		},
		selectAll() {
			this.Arrauthorized = [];
			let selected = this.Arrauthorized;
			if(this.search.authorized!=1){
				let vm=this;
				this.checks_s.forEach(element => {
					if (!selected.includes(element.id)&&((vm.search.type_payment_id!=6&&element.type_payment_id!=6) || (vm.search.type_payment_id==6&&element.type_payment_id==6))) {
						selected.push(element.id);
					}
				});
			}else
				this.advances_s.forEach(element => {
					if (!selected.includes(element.id)) {
						selected.push(element.id);
					}
				});
			this.Arrauthorized = selected;
		},
		deselectAll() {
			this.Arrauthorized = [];
		},
		async changePage(page = 1){
			if(this.search.authorized==1)
				this.advances_s=this.advances_p[page-1];
			else
				this.checks_s=this.checks_p[page-1];
		},
		async sortPage(name){
			switch(name){
				case 'id':
					this.order.id++;
					if(this.order.id%2==0)
						if(this.search.authorized==1)
							this.advances=this.advances.sort((a,b)=>{
								return a.id - b.id
							});
						else
							this.checks=this.checks.sort((a,b)=>{
								return a.id - b.id
							});
					else
						if(this.search.authorized==1)
							this.advances=this.advances.sort((a,b)=>{
								return b.id - a.id
							});
						else
							this.checks=this.checks.sort((a,b)=>{
								return b.id - a.id
							});
					this.order.name=-1;
					this.order.amount=-1;
					this.order.paid=-1;
					this.order.date=-1;
					this.order.approved=-1;
				break;
				case 'name':
					this.order.name++;
					if(this.order.name%2==0)
						if(this.search.authorized==1){
							this.advances=this.advances.sort((a,b)=>{
								return a.user.name.localeCompare(b.company.name)
							});
							this.advances=this.advances.sort((a,b)=>{
								return a.company.name.localeCompare(b.company.name)
							});
						}else {
							this.checks=this.checks.sort((a,b)=>{
								return a.user.name.localeCompare(b.user.name)
							});
							this.checks=this.checks.sort((a,b)=>{
								return a.advance.company.name.localeCompare(b.advance.company.name)
							});
						}
					else
						if(this.search.authorized==1){
							this.advances=this.advances.sort((a,b)=>{
								return b.user.name.localeCompare(a.company.name)
							});
							this.advances=this.advances.sort((a,b)=>{
								return b.company.name.localeCompare(a.company.name)
							});
						}else{
							this.checks=this.checks.sort((a,b)=>{
								return b.user.name.localeCompare(a.user.name)
							});
							this.checks=this.checks.sort((a,b)=>{
								return b.advance.company.name.localeCompare(a.advance.company.name)
							});
						}
					this.order.id=-1;
					this.order.amount=-1;
					this.order.paid=-1;
					this.order.date=-1;
					this.order.approved=-1;
				break;
				case 'amount':
					this.order.amount++;
					if(this.order.amount%2==0)
						if(this.search.authorized==1)
							this.advances=this.advances.sort((a,b)=>{
								return a.amount- b.amount
							});
						else 
							this.checks=this.checks.sort((a,b)=>{
								return a.amount- b.amount
							});
					else
						if(this.search.authorized==1)
							this.advances=this.advances.sort((a,b)=>{
								return b.amount- a.amount
							});
						else
							this.checks=this.checks.sort((a,b)=>{
								return b.amount- a.amount
							});
					this.order.id=-1;
					this.order.name=-1;
					this.order.paid=-1;
					this.order.date=-1;
					this.order.approved=-1;
				break;
				case 'paid':
					this.order.paid++;
					if(this.order.paid%2==0)
						this.checks=this.checks.sort((a,b)=>{
							return a.sum_pays- b.sum_pays
						});
					else
						this.checks=this.checks.sort((a,b)=>{
							return b.sum_pays- a.sum_pays
						});
					this.order.id=-1;
					this.order.name=-1;
					this.order.amount=-1;
					this.order.date=-1;
					this.order.approved=-1;
				break;
				case 'date':
					this.order.date++;
					if(this.order.date%2==0)
						if(this.search.authorized==1)
							this.advances=this.advances.sort((a,b)=>{
								return new Date(a.date) - new Date(b.date)
							});
						else 
							this.checks=this.checks.sort((a,b)=>{
								return new Date(a.advance.date) - new Date(b.advance.date)
							});
					else
						if(this.search.authorized==1)
							this.advances=this.advances.sort((a,b)=>{
								return new Date(b.date) - new Date(a.date)
							});
						else
							this.checks=this.checks.sort((a,b)=>{
								return new Date(b.advance.date) - new Date(a.advance.date)
							});
					this.order.id=-1;
					this.order.amount=-1;
					this.order.paid=-1;
					this.order.name=-1;
					this.order.approved=-1;
				break;
				case 'approved':
					this.order.approved++;
					if(this.order.approved%2==0)
						this.checks=this.checks.sort((a,b)=>{
							return new Date(a.authorization_date) - new Date(b.authorization_date)
						});
					else
						this.checks=this.checks.sort((a,b)=>{
							return new Date(b.authorization_date) - new Date(a.authorization_date)
						});
					this.order.id=-1;
					this.order.amount=-1;
					this.order.paid=-1;
					this.order.retention=-1;
					this.order.name=-1;
					this.order.date=-1;
				break;
			}
		},
		async list() {
			this.order={
				id:-1,
				name:-1,
				amount:-1,
				paid:-1,
				date:0,
				approved:-1,
			};
			this.init=false;
			this.load = true;
			this.advances=[];
			this.checks=[];
			this.page=1;
			let service = request;
			let search = this.search, _endpoint='';
			if(this.search.authorized==1){
				_endpoint = '/share_advances';
			}else{
				_endpoint = '/pays';
			}
			search.search = this.name;
			try {
				let { data } = await service.list(_endpoint,this.page, search)
				if (data) {

					this.init=this.search.company_id == '' &&
					this.search.type_payment_id == '' &&
					this.search.user_id == '' &&
					(this.search.date == '' || this.search.date[0]==null);
					if(this.search.authorized==1){
						this.advances = data.data;
					}else{
						this.checks = data.data;
					}
					this.sortPage('date');
					if(data.dates[0]!=''){
						this.trigger=false;
						this.search.date = data.dates;
					}
					this.load = false;
					this.Arrauthorized = [];
				}
			} catch (error) {
				console.log(error);
				this.load = false;
			}
			this.Load=false;
		},
		...mapMutations({
			setHeaderTitle: 'setHeaderTitle',
		}),
		...mapActions({
			resetPassword: 'auth/resetPass',
			errorNotification: 'alert/error',
			successNotification: 'alert/success',
		}),
	},
	watch: {
		'advances': {
			handler: function () {
				if(this.advances.length>0){
					let vm=this,k=0,j=1;
					this.advances_p=[];
					this.advances_p[0]=[];
					this.advances.forEach(s=>{
						vm.advances_p[k].push(s);
						if(j%vm.per_page==0){
							k++;
							vm.advances_p[k]=[];
						}
						j++;

					});
					this.advances_s=this.advances_p[this.page-1];
				}else{
					this.advances_p=[];
					this.advances_s=[];
				}
			},
			deep: true
		},
		'checks': {
			handler: function () {
				if(this.checks.length>0){
					let vm=this,k=0,j=1;
					this.checks_p=[];
					this.checks_p[0]=[];
					this.checks.forEach(p=>{
						vm.checks_p[k].push(p);
						if(j%vm.per_page==0){
							k++;
							vm.checks_p[k]=[];
						}
						j++;

					});
					this.checks_s=this.checks_p[this.page-1];
				}else{
					this.checks_p=[];
					this.checks_s=[];
				}
			},
			deep: true
		},
		'per_page': {
			handler: function () {
				this.page=1;
				if(this.advances.length>0){
					let vm=this,k=0,j=1;
					this.advances_p=[];
					this.advances_p[0]=[];
					this.advances.forEach(s=>{
						vm.advances_p[k].push(s);
						if(j%vm.per_page==0){
							k++;
							vm.advances_p[k]=[];
						}
						j++;

					});
					this.advances_s=this.advances_p[this.page-1];
				} else if(this.checks.length>0){
					let vm=this,k=0,j=1;
					this.checks_p=[];
					this.checks_p[0]=[];
					this.checks.forEach(p=>{
						vm.checks_p[k].push(p);
						if(j%vm.per_page==0){
							k++;
							vm.checks_p[k]=[];
						}
						j++;

					});
					this.checks_s=this.checks_p[this.page-1];
				}
			},
			deep: true
		},
		'view': {
			handler: function () {
				this.list();
				if(this.search.authorized==1){
					this.search.user_id='';
					this.search.type_payment_id='';
				}
			},
			deep: true
		},
		'search': {
			handler: function () {
				if(this.trigger){
					this.list();
				}else
					this.trigger=true;
			},
			deep: true
		}
	},
	computed: {
		...mapGetters({
			'authUser': 'auth/user'
		})
	},
}
</script>

<template>
	<div class="col-12">
		<div class="card card-outline card-navy">
			<div class="card-header">
				<h3 class="card-title">Lista de Adelantos</h3>
				<div class="card-tools">
					<button @click="newAdvance()" class="btn btn-sm btn-outline-primary">
						<i class="fa fa-plus"></i> Adelanto
					</button>
				</div>
			</div>
			<div class="card-body">
				<div class="row">
					<div class="col-12 p-2">
						<div class="row">
							<div class="col-md-6">
								<label>Rango de fechas :</label>
								<date-picker format="YYYY-MM-DD" valueType="format" :range="true"
									v-model="search.date"></date-picker>
							</div>
							<div class="col-md-6">
								<label>Empresa :</label>

								<select v-model="search.company_id" class="form-control" v-if="authUser.organization_charts_id != 10 && authUser.organization_charts_id != 15">
									<option value=""> Sin empresa </option>
									<option v-for="(company, index) in catalogue.companies_buildings" :value="company.id" :key="index">
										{{ company.name }}</option>
								</select>

								<select v-model="search.company_id" class="form-control" v-else>
									<option value=""> Sin empresa </option>
									<option v-for="(company, index) in catalogue.companies_users" :value="company.id" :key="index">
										{{ company.name }}
									</option>
								</select>
							</div>
							<div class="col-md-6 mt-2">
								<label>Socio :</label>
								<select type="text" class="form-control" v-model="search.user_id">
									<option value="">Todos</option>
									<option v-for="(user, index) in catalogue.users_profile" :value="user.id" :key="index">
										{{ user.name }} {{ user.last_name }}</option>
								</select>
							</div>
							<div class="col-md-6 mt-2" v-if="search.authorized!=1">
								<label>Tipo de pago</label>
								<select type="text" class="form-control" v-model="search.type_payment_id">
									<option value="">Todos</option>
									<option v-for="(type_payment, index_type_payment) in catalogue.type_payments"
										:value="type_payment.id" :key="index_type_payment">{{ type_payment.name }}</option>
								</select>
							</div>
						</div>
					</div>
				</div>
				<br>
				<div class="row">
					<div class="col-md-6">
						<ul class="nav nav-tabs" id="custom-tabs-one-tab" role="tablist">
							<li class="nav-item">
								<a class="nav-link active" @click="search.paid = 0, search.authorized = 1" data-toggle="pill" role="tab"
									aria-selected="true">Adelantos</a>
							</li>
							<!-- <li class="nav-item">
								<a class="nav-link" @click="search.paid = 0, search.authorized = 0" data-toggle="pill" role="tab"
									aria-selected="false">Aprobados</a>
							</li>
							<li class="nav-item">
								<a class="nav-link" @click="search.authorized = 0, search.paid = 1" data-toggle="pill" role="tab"
									aria-selected="false">Pagados</a>
							</li> -->
						</ul>
					</div>
					<div class="col-md-6">
						<!-- <button class="btn btn-outline-success btn-sm mr-2" v-can="'export_advance'"
							@click="exportData()">
							<i class="fa fa-file-excel"></i> Exportar
						</button> -->
						<label>
							<ul class="nav nav-tabs" id="custom-tabs-one-tab" role="tablist">
								<li class="nav-item">
									<label class="nav-link">Resultados por P&aacute;gina:</label>
								</li>
								<li class="nav-item">
									<a class="nav-link active" @click="per_page = 10" data-toggle="pill" aria-selected="true">10</a>
								</li>
								<li class="nav-item">
									<a class="nav-link" @click="per_page = 20" data-toggle="pill" aria-selected="false">20</a>
								</li>
								<li class="nav-item">
									<a class="nav-link" @click="per_page = 50" data-toggle="pill" aria-selected="false">50</a>
								</li>
							</ul>
						</label>
					</div>
				</div>
				<div class="table-responsive" v-if="search.authorized==1">
					<table class="table table-bordered text-center text-sm">
						<thead>
							<tr>
								<th>ID
									<button class="btn btn-xs" @click.prevent="sortPage('id')">
										<i class="fa" :class="order.id==-1?'fa-minus':(order.id%2==0?'fa-arrow-up':'fa-arrow-down')"></i>
									</button>
								</th>
								<th>Compañía
									<button class="btn btn-xs" @click.prevent="sortPage('name')">
										<i class="fa" :class="order.name==-1?'fa-minus':(order.name%2==0?'fa-arrow-up':'fa-arrow-down')"></i>
									</button>
								</th>
								<th>Fecha
									<button class="btn btn-xs" @click.prevent="sortPage('date')">
										<i class="fa" :class="order.date==-1?'fa-minus':(order.date%2==0?'fa-arrow-up':'fa-arrow-down')"></i>
									</button>
								</th>
								<th>Monto
									<button class="btn btn-xs" @click.prevent="sortPage('amount')">
										<i class="fa" :class="order.amount==-1?'fa-minus':(order.amount%2==0?'fa-arrow-up':'fa-arrow-down')"></i>
									</button>
								</th>
								<th>Opciones</th>
								<th v-if="paymentConditions()" class="text-center">
									<button v-if="Arrauthorized.length<advances_s.length" class="btn btn-sm btn-info" @click.prevent="selectAll">
										<i class="fa-solid fa-check-square"></i>
									</button>
									<button v-else class="btn btn-sm btn-info" @click.prevent="deselectAll">
										<i class="fa-solid fa-square"></i>
									</button>
								</th>
							</tr>
						</thead>
						<tbody v-if="load">
							<tr>
								<td align="center" colspan="8">
									<i class="fa-solid fa-circle-notch fa-spin fa-3x mb-1"></i>
									<h5>Cargando</h5>

								</td>
							</tr>
						</tbody>
						<tbody v-else-if="advances_s && advances_s.length > 0">
							<tr v-for="(advance, index) in advances_s" :key="index">
								<td>
									{{ advance.id }}
								</td>
								<td>
										<strong>Socio : </strong>
										<span v-if="authUser.organization_charts_id==1 || authUser.companies.some((spec, index) => { return spec.id == advance.company_id })">{{advance.user.name}} {{advance.user.last_name}}</span>
										<span v-else-if="check.user">XXXXXXXXXXX</span>
										<span v-else>Sin usuario</span>
										<!-- <span v-else>No Aplica</span> -->
										<br>
										<strong>Compañías : </strong>
										<span v-for="(company,index2) in advance.companies" :key="index2">{{ company.company.name }}<br></span>
										<button v-if="advance.approved_at"
											class="btn m-1 btn-success btn-sm">
											Aprobado
										</button>
								</td>
								<td>{{ advance.date | toDateTime }}</td>
								<td>{{ advance.companies_sum_amount | toCurrency }}</td>
								<td>
									<button @click="approve(advance)"
										v-if="!advance.approved_at"
										class="btn m-1 btn-outline-success btn-sm">
										<i class="fas fa-check "> </i> Aprobar
									</button>
									<!-- <button @click="approve(advance)"
										v-if="advance.checks.length == 0"
										class="btn m-1 btn-outline-success btn-sm">
										<i class="fas fa-check "> </i> Aprobar
									</button> -->

									<button @click="newAdvance(advance, true)"
										v-if="!advance.approved_at"
										class="btn m-1 btn-outline-primary btn-sm">
										<i class="fas fa-edit "> </i> Editar
									</button>
									<!-- <button @click="newAdvance(advance, true)"
										v-if="advance.checks.length == 0"
										class="btn m-1 btn-outline-primary btn-sm">
										<i class="fas fa-edit "> </i> Editar
									</button> -->
									<button @click="newAdvance(advance, false)"
										class="btn m-1 btn-outline-secondary btn-sm">
										<i class="fas fa-eye "> </i> Ver más
									</button>
									<!-- <button @click="downloadPDF(advance.id)" type="button"
										class="btn btn-sm  m-1 btn-outline-info "
										v-if="authUser.organization_charts_id==1 || authUser.companies.some((spec, index) => { return spec.id == advance.company_id })"
										>
										<i class="fa-solid fa-eye"></i> Descargar PDF
									</button> -->
									<button type="button" @click="deleted(advance)"
										v-if="!advance.approved_at"
										class="btn m-1 btn-outline-danger btn btn-sm ">
										<i class="fa fa-trash"></i> Eliminar
									</button>
									<!-- <button type="button" @click="deleted(advance.id)"
										v-if="advance.checks.length == 0"
										class="btn m-1 btn-outline-danger btn btn-sm ">
										<i class="fa fa-trash"></i> Eliminar
									</button> -->
								</td>
								<th class="text-center" v-can="'add_pays_fast'" v-if="paymentConditions()">
									<input type="checkbox"
										class="form-control form-control-sm" :value="advance.id" v-model="Arrauthorized">																		
								</th>
							</tr>
						</tbody>
						<tbody v-else>
							<tr>
								<td align="center" colspan="9">Sin resultados.</td>
							</tr>
						</tbody>
						<tfoot v-if="advances_p && advances_p.length > 0 && load == false">
							<tr class="table-secondary">
								<td colspan="3">
									Total :
								</td>
								<td class="text-right">
									{{ sumdata() | toCurrency }}
								</td>
								<td></td>
							</tr>
						</tfoot>
					</table>
					<pagination v-model="page" :records="parseInt(advances?advances.length:0)" :per-page="parseInt(per_page)"
						@paginate="changePage" />
				</div>
				<div class="table-responsive" v-else>
					<table class="table table-bordered text-sm text-center">
						<thead>
							<tr>
								<th>ID
									<button class="btn btn-xs" @click.prevent="sortPage('id')">
										<i class="fa" :class="order.id==-1?'fa-minus':(order.id%2==0?'fa-arrow-up':'fa-arrow-down')"></i>
									</button>
								</th>
								<th style="width: 45%;">Datos
									<button class="btn btn-xs" @click.prevent="sortPage('name')">
										<i class="fa" :class="order.name==-1?'fa-minus':(order.name%2==0?'fa-arrow-up':'fa-arrow-down')"></i>
									</button>
								</th>
								<th style="width: 140px;">Monto
									<button class="btn btn-xs" @click.prevent="sortPage('amount')">
										<i class="fa" :class="order.amount==-1?'fa-minus':(order.amount%2==0?'fa-arrow-up':'fa-arrow-down')"></i>
									</button>
								</th>
							<!--	<th style="width: 140px;">Por pagar</th> -->
								<th style="width: 140px;">Pagado
									<button class="btn btn-xs" @click.prevent="sortPage('paid')">
										<i class="fa" :class="order.paid==-1?'fa-minus':(order.paid%2==0?'fa-arrow-up':'fa-arrow-down')"></i>
									</button>
								</th>
								<th>Fecha de aprobación
									<button class="btn btn-xs" @click.prevent="sortPage('approved')">
										<i class="fa" :class="order.approved==-1?'fa-minus':(order.approved%2==0?'fa-arrow-up':'fa-arrow-down')"></i>
									</button>
								</th>
							<!--	<th>Fecha de creación</th> -->
								<th>Fecha de adelanto
									<button class="btn btn-xs" @click.prevent="sortPage('date')">
										<i class="fa" :class="order.date==-1?'fa-minus':(order.date%2==0?'fa-arrow-up':'fa-arrow-down')"></i>
									</button>
								</th>
								<th class="text-center">Opciones</th>
								<th v-can="'add_pays_fast'" v-if="paymentConditions()" class="text-center">
									<button v-if="Arrauthorized.length<checks_s.filter(c=>c.type_payment_id!=6).length" class="btn btn-sm btn-info" @click.prevent="selectAll">
										<i class="fa-solid fa-check-square"></i>
									</button>
									<button v-else class="btn btn-sm btn-info" @click.prevent="deselectAll">
										<i class="fa-solid fa-square"></i>
									</button>
								</th>
								<th v-can="'add_pays_fast'" v-if="paymentConditionsCheck()" class="text-center">
									<button v-if="Arrauthorized.length<checks_s.length" class="btn btn-sm btn-info" @click.prevent="selectAll">
										<i class="fa-solid fa-check-square"></i>
									</button>
									<button v-else class="btn btn-sm btn-info" @click.prevent="deselectAll">
										<i class="fa-solid fa-square"></i>
									</button>
								</th>
							</tr>
						</thead>
						<tbody v-if="load">
							<tr>
								<td align="center" colspan="10">
									<i class="fa-solid fa-circle-notch fa-spin fa-3x mb-1"></i>
									<h5>Cargando</h5>

								</td>
							</tr>
						</tbody>
						<tbody v-else-if="checks_s.length > 0">
							<tr v-for="(check, index) in checks_s" :key="index">
								<td>{{ check.id }}</td>
								<td class="text-left">
									<!-- Tipo -->
									<!-- Nomina -->
									<span v-if="check.advance_id">
										<strong>Socio : </strong>
										<span v-if="check.user&&(authUser.organization_charts_id==1 || authUser.companies.some((spec, index) => { return spec.id == check.advance.company_id }))">{{check.user.name}} {{check.user.last_name}}</span>
										<span v-else-if="check.user">XXXXXXXXXXX</span>
										<span v-else>Sin usuario</span>
										<span v-if="(user=check.advance.users.filter((user, index) => { return (user.id == check.user_id)})[0]) && (bank = check.user.bank_accounts.filter((bank, index) => { return (user.pivot.bank_account_id == bank.id)})[0])">
										<br>
											<strong>Cuenta bancaria: </strong>
											<span v-if="authUser.organization_charts_id==1 || authUser.companies.some((spec, index) => { return spec.id == check.advance.company_id })">{{bank.account_number }}</span>
											<span v-else>XXXXXXXXXXX</span>
										</span>
										<!-- <span v-else>No Aplica</span> -->
										<br>
										<strong>Compañía : </strong>
										{{ check.advance.company.name }}<br>
										<strong>Fecha : </strong>
										{{ check.advance.date | toDateTime }}<br>
										
										<strong>Tipo de Pago : </strong>
										<span v-if="check.type_payment">
											{{ check.type_payment.name }}
										</span>
										<span v-else>Sin tipo</span>
										<br>
										<strong>Monto : </strong>
										{{ check.advance.amount | toCurrency }}<br>
									</span>
								</td>
								<td class="text-right">
									{{ (check.amount + check.credit) | toCurrency }}
								</td>
							<!--	<td class="text-right">
									<strong style="font-weight: 900;">{{ check.amount_payable | toCurrency }}</strong>
								</td> -->
								<td class="text-right">
									{{ check.sum_pays | toCurrency }}
								</td>
								<td>
									<span v-if="check.user_approved"> {{ check.authorization_date | toDateTime }} </span>
									<span v-else>Sin Fecha</span>
								</td>
							<!--	<td>
									{{ check.created_at | toDateTime }}
								</td> -->
								<td>
									<span v-if="check.advance">
										{{ check.advance.date | toDateTime }}
									</span>
									<span v-else>
										S/F
									</span>

								</td>
								<td class="text-center">
									<!-- <button v-if="check.advance&&check.type_payment && check.type_payment.name=='Dispersión'&&(authUser.organization_charts_id==1 || authUser.companies.some((spec, index) => { return spec.id == check.advance.company_id }))" @click="showAdvance(check.advance)"
										class="btn btn-outline-secondary m-1 btn-sm">
										<i class="fa-solid fa-receipt mr-1"></i> Ver adelanto
									</button> -->

									<div class="d-inline" v-if="check.pay && check.pay.length == 0">
										<button v-if="check.advance_id && check.type_payment_id != 6"
											@click="formDataPayFast(check)"
											class="btn btn-outline-secondary m-1 btn-sm">
											<i class="fa-solid fa-receipt mr-1"></i> Pago rápido
										</button>

										<button v-if="check.advance_id && check.type_payment_id == 6"
											@click="formDataPaysFastCheckbook(check)"
											class="btn btn-outline-secondary m-1 btn-sm">
											<i class="fa-solid fa-receipt mr-1"></i> Pago rápido cheque
										</button>
									</div>

									<button type="button" v-if="check.advance_id && search.paid == 0" @click="deleted(check)"
										v-can="'deleted_checks'" class="btn-outline-danger btn m-1 btn-sm ">
										<i class="fa fa-trash"></i> Eliminar
									</button>
									<button @click="formListPays(check)" class="btn m-1 btn-sm btn-outline-warning">
										<i class="fa-solid fa-hand-holding-dollar mr-1"> </i>
										<span>Ver pago</span>
									</button>
								</td>
								<th class="text-center" v-can="'add_pays_fast'" v-if="paymentConditions()">
									<input type="checkbox" :disabled="check.type_payment_id == 6"
										class="form-control form-control-sm" :value="check.id" v-model="Arrauthorized">																		
								</th>
								<th class="text-center" v-can="'add_pays_fast'" v-if="paymentConditionsCheck()">
									<input type="checkbox" :disabled="check.type_payment_id != 6"
										class="form-control form-control-sm" :value="check.id" v-model="Arrauthorized">
									<br>
									<span v-if="check.checkbook" class="badge badge-info">
									{{ check.checkbook.name }}
									<br>-<br>
									{{ check.folio_prev }}
									</span>
								</th>
							</tr>
						</tbody>
						<tbody v-else>
							<tr>
								<td align="center" colspan="10">Sin resultados.</td>
							</tr>
						</tbody>
						<tfoot v-if="checks_s.length > 0 && load == false">
							<tr class="table-secondary">
								<td colspan="2">
									Total :
								</td>
								<td class="text-right">
									{{ sumdata()[0] | toCurrency }}
								</td>
								<!-- <td class="text-right">
									{{ sumdata()[1] | toCurrency }}
								</td> -->
								<td class="text-right">
									{{ sumdata()[2] | toCurrency }}
								</td>
								<td colspan="3"></td>
							</tr>
						</tfoot>
					</table>
					<pagination v-if="checks_s" v-model="page" :records="checks?checks.length:0" :per-page="per_page"
						@paginate="changePage" />
				</div>
				<div class="row mt-3" v-can="'add_pays_fast'" v-if="paymentConditions()">
					<div class="col-12 text-right">
						<button class="btn btn-outline-info" :disabled="Arrauthorized.length==0"
							v-if="!sendGroup && search.authorized == 0" @click="formDataPaysFastGroup()">
							<i class="fa-solid fa-list-check"></i> Pago rápido seleccionado
						</button>
						<button class="btn btn-outline-info" :disabled="Arrauthorized.length==0"
						v-else-if="!sendGroup && search.authorized == 1" @click="formDataApproveGroup()">
							<i class="fa-solid fa-list-check"></i>Aprobar seleccionados
						</button>
						<button class="btn btn-outline-info" disabled="true" v-else>
							<i class="fa-solid fa-circle-notch fa-spin"></i> Pagando
						</button>
					</div>
				</div>

				<div class="row mt-3" v-can="'add_pays_fast'" v-if="paymentConditionsCheck()">
					<div class="col-12 text-right">
						<button class="btn btn-outline-info" :disabled="Arrauthorized.length==0"
							v-if="!sendGroup && search.authorized == 0" @click="formDataPaysFastGroupCheck()">
							<i class="fa-solid fa-list-check"></i> Pago de cheque agrupado
						</button>
						<button class="btn btn-outline-info" disabled="true" v-else>
							<i class="fa-solid fa-circle-notch fa-spin"></i> Pagando
						</button>
					</div>
				</div>

			</div>
		</div>
		<ModalFormComponent :prop_edit="editAdvance" />
		<ModalTableComponentPays :prop_edit="false" />
		<ModalPayCheckbookFastComponent />
		<ModalPayGroupCheckbookFastComponent />
		<ModalDownloadFileComponent />
	</div>
</template>

<style scoped>
.pagination {
	margin-bottom: 0;
}

.fade-enter-active,
.fade-leave-active {
	transition: opacity .5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
	{
	opacity: 0;
}

.btn-xs {
  padding: 0.125rem 0.25rem;
  font-size: 0.70rem;
  line-height: 1.2;
}
</style>
